// extracted by mini-css-extract-plugin
export default {"root":"Grid_root__lcCVk","grid4":"Grid_grid4__N7QlW","grid3":"Grid_grid3__YRC2K","grid2":"Grid_grid2__ZaK6M","grid1":"Grid_grid1__-LuIv"};